import { gql } from 'src/generated/gql';

export const GET_BRIDGE_SUBMISSION = gql(`
  query GetBridgeSubmission($eventId: ID!) {
    staff_getBridgeSubmissionFromEvent(eventId: $eventId) {
      reason{
        version
        anythingElse
        needRefill
        currentPharmacy
        currentPharmacyNcpdpId
        outOf
        remainingBupeDoses
        pharmacyUpdated
        earlyRefillReason
      }
    }
  }
`);
